import { actionType } from './actions';

const initialState = {
    editPendingTrust: {},
    editPendingPortfolio: {},
    editPendingClass: {},
    pendingTrusts: [],
    pendingPortfolios: [],
    pendingClasses: [],
    selectedTrustItemData: {},
    selectedPortfolioItemData: {},
    selectedClassItemData: {},
    activeTabKey: 1,
    isGridItemSelected: false,
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_SECURITY_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.UPDATE_PENDING_TRUST:
        case actionType.UPDATE_PENDING_PORTFOLIO:
        case actionType.UPDATE_PENDING_CLASS: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.REJECTED_SECURITY_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_PENDING_TRUSTS: {
            return {
                ...state,
                pendingTrusts: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_EDIT_PENDING_TRUST_PAYLOAD: {
            return {
                ...state,
                editPendingTrust: action.payload,
                activeTabKey: 1
            };
        }

        case actionType.FETCH_PENDING_PORTFOLIOS: {
            return {
                ...state,
                pendingPortfolios: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_EDIT_PENDING_PORTFOLIO_PAYLOAD: {
            return {
                ...state,
                editPendingPortfolio: action.payload,
                activeTabKey: 2
            };
        }
        case actionType.FETCH_PENDING_CLASSES: {
            return {
                ...state,
                pendingClasses: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        case actionType.UPDATE_EDIT_PENDING_CLASS_PAYLOAD: {
            return {
                ...state,
                editPendingClass: action.payload,
                activeTabKey: 3
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/security/reducers.js